import { render, staticRenderFns } from "./specificAct.vue?vue&type=template&id=df1413dc&scoped=true"
import script from "./specificAct.vue?vue&type=script&lang=js"
export * from "./specificAct.vue?vue&type=script&lang=js"
import style0 from "./specificAct.vue?vue&type=style&index=0&id=df1413dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1413dc",
  null
  
)

export default component.exports